import type { Translation } from './translation';

/** Russian strings. The brand name «Ипотекалық дәрігер» stays in Kazakh here too. */
export const ru: Translation = {
    'brand.name': 'Ипотекалық дәрігер',

    'nav.home': 'Главная',
    'nav.portal': 'Личный кабинет',
    'nav.sign_in': 'Войти',
    'nav.sign_out': 'Выйти',
    'nav.language': 'Язык',
    'nav.book': 'Записаться',
    'nav.open_menu': 'Открыть меню',
    'nav.close_menu': 'Закрыть меню',

    'home.title': 'Ваш надёжный партнёр по ипотеке',
    'home.subtitle':
        'Мы упрощаем путь к ипотеке: подбор банковских программ, расчёты и подготовка документов.',
    'home.contact_us': 'Связаться',
    'home.portal_cta': 'Войти в личный кабинет',
    'home.contacts': 'Контакты',
    'home.phone': 'Телефон',
    'home.email': 'Электронная почта',
    'home.address': 'Адрес',
    'home.working_hours': 'Часы работы',
    'home.whatsapp': 'WhatsApp',

    'theme.to_dark': 'Переключить на тёмную тему',
    'theme.to_light': 'Переключить на светлую тему',

    'auth.aside.title': 'Весь путь к ипотеке — на одном экране',
    'auth.aside.point1': 'Видите, на каком этапе дело и какой шаг следующий',
    'auth.aside.point2': 'Все документы хранятся в одном месте',
    'auth.aside.point3': 'Задаёте вопрос консультанту напрямую',

    'auth.sign_in.title': 'Вход в личный кабинет',
    'auth.sign_in.subtitle': 'Введите почту, телефон или ИИН, которые вы дали своему консультанту.',
    'auth.sign_in.identifier': 'Почта, телефон или ИИН',
    'auth.sign_in.identifier_hint': 'Электронная почта, номер телефона или ИИН',
    'auth.sign_in.identifier_invalid': 'Введите электронную почту, номер телефона или ИИН',
    'auth.sign_in.recognised': 'Распознано:',
    'auth.sign_in.kind.email': 'электронная почта',
    'auth.sign_in.kind.phone': 'номер телефона',
    'auth.sign_in.kind.iin': 'ИИН',
    'auth.sign_in.password': 'Пароль',
    'auth.sign_in.submit': 'Войти',
    'auth.sign_in.no_account': 'Нет учётной записи?',
    'auth.sign_in.register': 'Зарегистрироваться',

    'auth.register.title': 'Регистрация',
    'auth.register.subtitle': 'Введите свои данные, чтобы открыть личный кабинет.',
    'auth.register.first_name': 'Имя',
    'auth.register.last_name': 'Фамилия',
    'auth.register.phone': 'Номер телефона',
    'auth.register.phone_hint': 'По этому номеру вы будете входить в кабинет.',
    'auth.register.phone_invalid': 'Введите казахстанский номер телефона',
    'auth.register.iin': 'ИИН (необязательно)',
    'auth.register.iin_hint': 'Вводится один раз и потом не меняется.',
    'auth.register.iin_invalid': 'Неверный ИИН',
    'auth.register.email': 'Электронная почта (необязательно)',
    'auth.register.email_hint': 'Если укажете, сможете входить и по ней.',
    'auth.register.password': 'Пароль',
    'auth.register.confirm_password': 'Повторите пароль',
    'auth.register.submit': 'Зарегистрироваться',
    'auth.register.have_account': 'Уже есть учётная запись?',

    'auth.activate.title': 'Создание пароля',
    'auth.activate.subtitle': 'Придумайте пароль, чтобы активировать кабинет.',
    'auth.activate.password': 'Новый пароль',
    'auth.activate.confirm_password': 'Повторите пароль',
    'auth.activate.submit': 'Сохранить и войти',
    'auth.activate.mismatch': 'Пароли не совпадают.',
    'auth.activate.too_short': 'Пароль должен содержать не менее 8 символов.',
    'auth.activate.missing_link': 'Ссылка неполная. Попросите консультанта прислать новую.',
    'auth.activate.success': 'Пароль сохранён. Теперь вы можете войти.',

    'portal.title': 'Личный кабинет',
    'portal.welcome': 'Добро пожаловать',
    'portal.empty': 'Пока нет дел для отображения. Напишите нам или позвоните, если есть вопросы.',
    'portal.loading': 'Загрузка…',

    'portal.cases': 'Мои дела',
    'portal.case_number': 'Номер дела',
    'portal.opened': 'Открыто',
    'portal.closed': 'Закрыто',
    'portal.in_progress': 'В работе',
    'portal.stage': 'Этап',
    'portal.no_stage': 'Этап пока не указан.',
    'portal.next_action': 'Следующий шаг',
    'portal.due': 'Срок',
    'portal.progress': 'Ход дела',
    'portal.open_case': 'Подробнее',
    'portal.back_to_portal': 'Вернуться в кабинет',
    'portal.case_not_found': 'Дело не найдено.',

    'portal.appointments': 'Встречи',
    'portal.no_appointments': 'Запланированных встреч нет.',
    'portal.case_appointments': 'Встречи по этому делу',

    'portal.case_documents': 'Документы',
    'portal.no_documents': 'Открытых вам документов пока нет.',
    'portal.document_download': 'Скачать',
    'portal.document_downloading': 'Загрузка…',
    'portal.document_unavailable': 'Документ недоступен. Обновите страницу.',
    'portal.signature_requests': 'Запросы на подпись',
    'portal.no_signature_requests': 'Документов, ожидающих подписи, нет.',
    'portal.signature_expires': 'Действует до',
    'portal.signature_start': 'Расписаться от руки',
    'portal.signature_read_first':
        'Перед подписанием прочитайте документы выше. Подпись привязывается именно к тем редакциям, которые вам отправили.',
    'portal.signature_pad_label': 'Поле для подписи',
    'portal.signature_pad_placeholder': 'Распишитесь здесь мышью или пальцем',
    'portal.signature_clear': 'Стереть',
    'portal.signature_consent': 'Документы мной прочитаны, и я их подписываю.',
    'portal.signature_submit': 'Подписать документы',
    'portal.signature_submitting': 'Подписываем…',
    'portal.signature_cancel': 'Отмена',
    'portal.signature_ecp_start': 'Подписать ЭЦП',
    'portal.signature_ecp_signing': 'Подписываем ЭЦП…',
    'portal.signature_ecp_hint':
        'Для подписи ЭЦП нужен компьютер с запущенным NCALayer: он откроется, чтобы вы выбрали ключ и ввели пароль.',
    'portal.signature_ecp_required': 'Эти документы нужно подписать ЭЦП.',
    'portal.ncalayer_download': 'Скачать NCALayer',
    'portal.signature_done': 'Подписано.',
    'portal.appointment_status.requested': 'Заявка принята',
    'portal.appointment_status.confirmed': 'Подтверждена',
    'portal.appointment_status.completed': 'Состоялась',
    'portal.appointment_status.cancelled': 'Не состоится',
    'portal.appointment_no_time': 'Время пока не согласовано',
    'portal.format.online': 'Онлайн',
    'portal.format.in_person': 'В офисе',
    'portal.duration_minutes': 'мин',

    'portal.messages': 'Вопросы',
    'portal.messages_hint':
        'Если нужно перенести или отменить встречу, напишите здесь — консультант внесёт изменения.',
    'portal.message_placeholder': 'Напишите ваш вопрос',
    'portal.send': 'Отправить',
    'portal.sending': 'Отправляем…',
    'portal.no_messages': 'Пока нет сообщений.',
    'portal.load_earlier': 'Показать более ранние сообщения',
    'portal.you': 'Вы',
    'portal.staff': 'Консультант',
    'portal.seen': 'Прочитано',
    'portal.message_required': 'Напишите текст сообщения.',

    'portal.book_appointment': 'Записаться на встречу',
    'portal.empty_title': 'Пока нет открытых дел',
    'portal.no_appointments_hint': 'Как только вы запишетесь на консультацию, встреча появится здесь.',
    'portal.no_documents_hint': 'Когда консультант откроет вам документ, он появится здесь.',
    'portal.no_signature_requests_hint': 'Когда потребуется подпись, документ появится здесь.',
    'portal.signature_awaiting': 'Нужна подпись',
    'portal.step_done': 'Завершено',
    'portal.step_current': 'Текущий этап',
    'portal.step_upcoming': 'Впереди',
    'portal.contact_title': 'Связаться с нами',
    'portal.contact_hint': 'Есть вопрос — позвоните или напишите, консультант ответит.',
    'portal.stage_of': 'Этап {current} из {total}',
    'portal.nothing_needed': 'Сейчас от вас ничего не требуется',
    'portal.nothing_needed_hint': 'Когда понадобится ваше участие, вы увидите это здесь и в уведомлениях.',
    'portal.signature_needed_title': 'Нужна ваша подпись',
    'portal.signature_needed_hint': 'Запросов, ожидающих подписи: {count}',
    'portal.signature_needed_action': 'Перейти к подписанию',
    'portal.case_closed_title': 'Дело закрыто',
    'portal.case_closed_hint': 'Если остались вопросы, напишите или позвоните нам.',
    'portal.next_stage': 'Далее',
    'portal.next_appointment': 'Ближайшая встреча',
    'portal.earlier_appointments': 'Ранее',
    'portal.cancel_appointment': 'Отменить встречу',
    'portal.cancel_appointment_reason': 'Причина отмены',
    'portal.cancel_appointment_reason_placeholder': 'Например: изменились планы',
    'portal.cancel_appointment_reason_required': 'Укажите причину отмены.',
    'portal.cancel_appointment_confirm': 'Подтвердить отмену',
    'portal.cancel_appointment_sending': 'Отменяем…',
    'portal.cancel_appointment_keep': 'Не отменять',
    'portal.documents_failed': 'Не удалось загрузить документы. Обновите страницу.',
    'portal.signatures_failed_title': 'Не удалось проверить запросы на подпись',
    'portal.signatures_failed_hint': 'Обновите страницу. Если ошибка повторится, свяжитесь с нами.',
    'portal.pdf.download': 'Скачать PDF',
    'portal.pdf.downloading': 'Готовим PDF…',
    'portal.pdf.failed': 'Не удалось подготовить PDF. Попробуйте позже.',
    'portal.pdf.title': 'Справка по делу',
    'portal.pdf.generated_on': 'Сформировано',
    'portal.pdf.provenance': 'Выписка по делу {case} из личного кабинета.',
    'portal.pdf.footer': 'Документ носит информационный характер и не является решением или предложением банка.',
    'portal.pdf.summary': 'О деле',
    'portal.pdf.status': 'Состояние',
    'portal.pdf.column_service': 'Встреча',
    'portal.pdf.column_when': 'Время',
    'portal.pdf.column_document': 'Документ',
    'portal.pdf.column_shared': 'Открыт',
    'portal.pdf.consultation': 'Консультация',
    'portal.pdf.closed_note': 'Это дело закрыто.',

    'portal.notifications': 'Уведомления',
    'portal.no_notifications': 'Новых уведомлений нет.',
    'portal.mark_all_read': 'Отметить все как прочитанные',
    'portal.mark_read': 'Отметить как прочитанное',
    'portal.unread': 'непрочитанных',
    'portal.push_hint': 'Уведомления браузера',
    'portal.push_enable': 'Включить',
    'portal.push_disable': 'Выключить',
    'portal.push_blocked': 'Браузер запретил уведомления.',

    'portal.notification.case_milestone': 'Дело {caseNumber} перешло на новый этап: {milestone}',
    'portal.notification.appointment_confirmed': 'Встреча подтверждена: {date}, {time}',
    'portal.notification.appointment_confirmed_no_time': 'Ваша встреча подтверждена.',
    'portal.notification.appointment_cancelled': 'Встреча не состоится. Свяжитесь с нами.',
    'portal.notification.message_received': 'Ответ консультанта: {preview}',
    'portal.notification.message_received_short': 'Ответ консультанта.',
    'portal.notification.document_shared': 'Вам открыт новый документ: {title}',
    'portal.notification.unknown': 'Новое уведомление.',

    'portal.language': 'Язык сообщений',
    'portal.language_hint': 'На этом языке мы пишем приглашения, напоминания и письма.',
    'portal.language_saved': 'Сохранено.',

    'portal.sections': 'Разделы кабинета',
    'portal.profile': 'Профиль',
    'portal.personal_details': 'Личные данные',
    'portal.full_name': 'Имя и фамилия',
    'portal.phone': 'Телефон',
    'portal.email': 'Электронная почта',
    'portal.not_given': 'Не указано',
    'portal.iin': 'ИИН',
    'portal.iin_hint':
        'ИИН нужен, чтобы подписывать документы ЭЦП. Вводится один раз и потом не меняется.',
    'portal.iin_save': 'Сохранить',
    'portal.iin_confirm_title': 'Проверьте номер',
    'portal.iin_confirm_hint': 'После сохранения изменить ИИН будет нельзя.',
    'portal.iin_confirm': 'Да, сохранить',
    'portal.iin_edit': 'Исправить',
    'portal.iin_saving': 'Сохраняем…',
    'portal.iin_saved': 'ИИН сохранён.',
    'portal.iin_recorded_hint': 'ИИН не меняется. Если в нём ошибка, свяжитесь с консультантом.',

    'booking.title': 'Запись на бесплатную консультацию',
    'booking.progress': 'Шаги записи',
    'booking.closed': 'Онлайн-запись сейчас закрыта. Позвоните нам — согласуем время по телефону.',
    'booking.back': 'Назад',
    'booking.next': 'Далее',
    'booking.submit': 'Отправить заявку',
    'booking.submitting': 'Отправляем…',
    'booking.free': 'Бесплатно',
    'booking.minutes': 'мин',
    'booking.loading_services': 'Загружаем услуги…',
    'booking.loading_slots': 'Загружаем свободное время…',
    'booking.no_days': 'На ближайшие дни свободного времени нет. Позвоните нам.',
    'booking.first_name': 'Имя',
    'booking.last_name': 'Фамилия',
    'booking.phone': 'Телефон',
    'booking.email': 'Электронная почта',
    'booking.too_many_submissions':
        'Слишком много заявок подряд. Подождите немного или позвоните нам.',

    'booking.consent':
        'Отправляя заявку, я даю согласие на обработку моих имени, номера телефона и электронной почты для записи на консультацию.',
    'booking.consent_link': 'Политика конфиденциальности',
    'booking.consent_required': 'Чтобы продолжить, дайте согласие на обработку данных.',
    'booking.specialist_unavailable':
        'Этот специалист сейчас не принимает записи. Выберите другого или пропустите выбор.',
    'booking.slot_taken': 'Занято',
    'booking.step.service': 'Услуга',
    'booking.step.format': 'Формат встречи',
    'booking.step.city': 'Город',
    'booking.step.specialist': 'Специалист',
    'booking.step.day': 'Дата и время',
    'booking.step.time': 'Время',

    'booking.format.online': 'Онлайн',
    'booking.format.in_person': 'В офисе',

    'booking.day.closed': 'В этот день мы не работаем',
    'booking.day.fully_booked': 'На этот день свободного времени не осталось',
    'booking.day.unavailable': 'День недоступен',

    'booking.success.title': 'Заявка принята',
    'booking.success.slot_held':
        'Выбранное время удерживается за вами. Мы свяжемся в ближайшее время, чтобы подтвердить запись.',
    'booking.success.call_back': 'Мы свяжемся в ближайшее время и согласуем удобное время.',
    'booking.success.home': 'На главную',

    'booking.nav.back': 'На главную',
    'booking.err.title': 'Ошибка',
    'booking.step.details': 'Данные',
    'booking.s1.step': '1 / 4 · Услуга',
    'booking.s1.title': 'Выберите тип услуги',
    'booking.s1.paid': 'Платно',
    'booking.s1.select': 'Выберите услугу',
    'booking.s1.placeholder': '— Выберите —',
    'booking.s1.selected': '✓ Выбрано',
    'booking.s1.offline_desc': 'Личная встреча в офисе. Вы выбираете дату и время.',
    'booking.s1.online_desc': 'По видео или телефону. Консультант свяжется с вами.',
    'booking.s1.skip_notice':
        'При онлайн-консультации время заранее не выбирается — мы свяжемся и согласуем.',
    'booking.s1.free_in_person': 'Бесплатная консультация проводится только в офисе.',
    'booking.s2s.step': '2 / 4 · Специалист',
    'booking.s2s.title': 'Выберите специалиста',
    'booking.s2s.hint':
        'Менеджера можно выбрать, ориентируясь на его ⭐ рейтинг.\nРейтинг отражает результаты и показатели работы менеджера за предыдущий месяц.',
    'booking.s2s.any': 'Не важно',
    'booking.s2s.any_desc': 'Назначим свободного консультанта',
    'booking.s2s.loading': 'Загружаем специалистов…',
    'booking.s2s.none': 'Сейчас выбирать не из кого — передадим заявку консультанту сами.',
    'booking.s2.step': '3 / 4 · Дата и время',
    'booking.s2.title': 'Выберите удобное время',
    'booking.s2.pick_date': 'Сначала выберите день',
    'booking.s2.none_for_specialist':
        'У этого специалиста нет свободного времени по этой услуге. Вернитесь назад и выберите другого или пропустите выбор.',
    'booking.s2.prev_weeks': 'Предыдущие недели',
    'booking.s2.next_weeks': 'Следующие недели',
    'booking.slots.morning': '☀️ Утро',
    'booking.slots.afternoon': '🌤️ День',
    'booking.slots.evening': '🌆 Вечер',
    'booking.s3.step': '4 / 4 · Данные',
    'booking.s3.title': 'Ваши контактные данные',
    'booking.s3.name_ph': 'Айгерим',
    'booking.s3.sname_ph': 'Бекова',
    'booking.s3.phone_ph': '700 000 00 00',
    'booking.s3.signed_in': 'Данные взяты из вашего личного кабинета.',
    'booking.s3.profile_loading': 'Загружаем ваши данные…',
    'booking.s3.other_person': 'Чтобы записать другого человека, выйдите из кабинета.',
    'booking.city.placeholder': '— Выберите город —',
    'booking.side.why': 'Почему выбирают нас?',
    'booking.side.f1_title': 'Надёжная консультация',
    'booking.side.f1_text': '5+ лет опыта, 7000+ успешных сделок',
    'booking.side.f2_title': 'Быстрый результат',
    'booking.side.f2_text': 'Предварительное одобрение за 4–8 часов',
    'booking.side.f3_title': 'Индивидуальный подход',
    'booking.side.f3_text': 'Для каждого клиента — отдельная стратегия',
    'booking.side.contact_note': 'Можно написать и в WhatsApp',

    "error.consent_outdated": "Обновите страницу и прочитайте актуальный текст согласия перед отправкой заявки.",
    "error.portal_no_account": "Активный профиль клиента отсутствует. Свяжитесь с консультантом.",
    "error.case_not_found": "Дело не найдено. Обновите страницу или свяжитесь с консультантом.",
    "error.document_not_found": "Документ недоступен. Обновите страницу или свяжитесь с консультантом.",
    "error.signature_not_found": "Запрос на подпись не найден. Обновите страницу.",
    "error.signature_too_many_strokes": "В подписи слишком много штрихов. Очистите поле и распишитесь заново.",
    "error.signature_off_pad": "Подпись выходит за границы поля. Очистите поле и распишитесь заново.",
    "error.session_ended": "Сеанс завершён. Войдите снова.",
    "error.session_superseded": "Сеанс завершён: в эту учётную запись вошли на другом устройстве. Войдите снова.",
    "error.forbidden": "У вас нет доступа к этому действию.",
    "error.not_found": "Запрошенные данные не найдены. Обновите страницу.",
    "error.conflict": "Данные изменились. Обновите страницу и попробуйте снова.",
    "error.booking_date_unavailable": "Эта дата недоступна для записи. Выберите другую.",
    "validation.invalid": "Проверьте значение этого поля.",
    "validation.out_of_range": "Значение вне допустимого диапазона.",
    "validation.password_symbol": "Добавьте в пароль хотя бы один специальный символ.",
    "validation.password_digit": "Добавьте в пароль хотя бы одну цифру.",
    "validation.password_lowercase": "Добавьте в пароль хотя бы одну строчную латинскую букву.",
    "validation.password_uppercase": "Добавьте в пароль хотя бы одну заглавную латинскую букву.",
    "validation.password_unique": "Используйте в пароле больше различных символов.",
    'error.generic': 'Непредвиденная ошибка. Попробуйте позже.',
    'error.network': 'Нет связи с сервером. Проверьте подключение к интернету.',
    'error.invalid_credentials': 'Неверные данные для входа.',
    'error.locked_out': 'Учётная запись временно заблокирована. Попробуйте позже.',
    'error.invalid_invitation': 'Ссылка недействительна или истекла. Попросите у консультанта новую.',
    'error.too_many_requests': 'Слишком много попыток. Подождите немного и повторите.',
    'error.phone_already_in_use': 'Этот номер уже зарегистрирован. Попробуйте войти с ним.',
    'error.iin_already_in_use': 'Этот ИИН уже зарегистрирован. Попробуйте войти с ним.',
    'error.portal_iin_fixed': 'ИИН уже сохранён. Если в нём ошибка, свяжитесь с консультантом.',
    'error.portal_iin_in_use': 'Этот ИИН указан в другом аккаунте. Свяжитесь с консультантом.',
    'error.email_already_in_use': 'Эта почта уже зарегистрирована. Попробуйте войти с ней.',
    'error.slot_taken': 'Это время только что заняли. Выберите другое.',
    'error.slot_not_offered': 'Это время не предлагается. Выберите одно из показанных.',
    'error.booking_closed': 'Онлайн-запись сейчас закрыта. Позвоните нам.',
    'error.service_unavailable': 'Эта услуга больше не предлагается. Выберите другую.',
    'error.signature_expired': 'Срок действия запроса истёк. Попросите консультанта отправить новый.',
    'error.signature_closed': 'Этот запрос больше не ждёт подписи. Обновите страницу.',
    'error.signature_already_signed': 'Вы уже подписали эти документы.',
    'error.signature_package_changed':
        'Документы изменились после отправки, поэтому подписать их нельзя. Свяжитесь с консультантом.',
    'error.signature_not_drawn': 'Распишитесь в поле перед тем, как подписать.',
    'error.signature_ecp_required': 'Эти документы нужно подписать ЭЦП.',
    'error.signature_manual_required': 'Эти документы нужно подписать от руки.',
    'error.ecp_service_unavailable': 'Сервис проверки подписи сейчас не отвечает. Попробуйте чуть позже.',
    'error.ecp_invalid': 'Подпись не прошла проверку. Попробуйте ещё раз.',
    'error.ecp_wrong_certificate': 'Выберите ключ для подписи, а не ключ для входа (AUTH).',
    'error.ecp_certificate_expired': 'Срок действия сертификата истёк. Получите новый ключ ЭЦП.',
    'error.ecp_certificate_revoked': 'Этот сертификат отозван. Получите новый ключ ЭЦП.',
    'error.ecp_iin_mismatch': 'Этот ключ ЭЦП выдан на другой ИИН. Подпишите своим ключом.',
    'error.ncalayer_unavailable': 'Не удалось подключиться к NCALayer. Запустите его на компьютере и попробуйте снова.',
    'error.ncalayer_timeout': 'NCALayer не ответил вовремя. Попробуйте снова.',
    'error.ncalayer_failed': 'Подписать не удалось. Проверьте выбранный ключ и пароль.',

    'validation.required': 'Заполните это поле',
    'validation.phone': 'Введите номер в формате +7 700 000 00 00',
    'validation.email': 'Введите корректный адрес электронной почты',
    'validation.too_short': 'Значение слишком короткое',
    'validation.too_long': 'Значение слишком длинное',
    'validation.format': 'Неверный формат',

    'nav.blog': 'Посты',

    'blog.title': 'Посты',
    'blog.subtitle': 'Статьи об ипотеке простым языком.',
    'blog.empty': 'Пока нет статей.',
    'blog.read_more': 'Читать',
    'blog.previous': 'Назад',
    'blog.next': 'Вперёд',

    'article.back_to_blog': 'Вернуться к постам',
    'article.gone.title': 'Статья снята с публикации',
    'article.gone.body': 'Эта статья была опубликована ранее и сейчас недоступна.',
    'article.missing.title': 'Статья не найдена',
    'article.missing.body': 'По этому адресу статьи нет. Проверьте ссылку.',
    'article.cta.title': 'Остались вопросы?',
    'article.cta.body': 'Запишитесь на бесплатную встречу с консультантом.',
    'article.cta.action': 'Записаться на консультацию',

    'share.title': 'Поделиться',
    'share.copy': 'Скопировать ссылку',
    'share.copied': 'Ссылка скопирована',
    'share.native': 'Другое приложение',

    'not_found.title': 'Страница не найдена',
    'not_found.body': 'Возможно, страница удалена или её адрес изменился.',
    'not_found.home': 'Вернуться на главную',

    'common.optional': 'необязательно',
    'common.loading': 'Загрузка…',

    // ── The public marketing pages ────────────────────────────────────────────
    'site.page.title': 'Ипотекалық дәрігер — Ваши надёжные ипотечные эксперты',
    'site.page.desc': 'Ипотекалық дәрігер — ваши надёжные ипотечные эксперты. Мы упрощаем путь к покупке жилья.',
    'site.nav.home': 'Главная',
    'site.nav.about': 'О нас',
    'site.nav.programs': 'Программы',
    'site.nav.faq': 'Вопросы',
    'site.nav.contact': 'Контакты',
    'site.nav.cta': 'Консультация',
    'site.hero.title': 'Ваши надёжные ипотечные эксперты',
    'site.hero.desc': 'Мы упрощаем путь к покупке жилья с помощью индивидуальных ипотечных решений, выгодных ставок и экспертной поддержки — от первой заявки до завершения сделки.',
    'site.hero.cta': 'Бесплатная консультация',
    'site.hero.posts': 'Читать посты',
    'site.hero.stat1': 'Лет опыта',
    'site.hero.stat2': 'Закрытых ипотек',
    'site.hero.stat3': 'Довольных клиентов',
    'site.about.label': 'Кто мы',
    'site.about.title': 'С 2021 года прокладываем\nпуть к собственному жилью',
    'site.about.subtitle': '«Ипотекалық дәрігер» создан с убеждением, что каждая семья достойна получить своё жильё открыто и без сложностей. Мы сочетаем глубокое знание рынка с искренней заботой о клиентах.',
    'site.about.cta': 'Начните свой путь',
    'site.ben1.title': 'Полностью регулируемая',
    'site.ben1.desc': 'Имеет разрешение FCA и регулируется. Ваши интересы всегда защищены.',
    'site.ben2.title': 'Лучшие ставки',
    'site.ben2.desc': 'Получите доступ к эксклюзивным ставкам, недоступным широкой публике.',
    'site.ben3.title': 'Поддержка 24/7',
    'site.ben3.desc': 'Наша команда готова помочь в любое время.',
    'site.ben4.title': 'Быстрое одобрение',
    'site.ben4.desc': 'Решения часто принимаются за несколько часов, а не дней.',
    'site.ben5.title': 'Команда экспертов',
    'site.ben5.desc': 'Квалифицированные консультанты с многолетним опытом.',
    'site.ben6.title': 'История результатов',
    'site.ben6.desc': 'Более 7 000 успешных ипотек и 98% довольных клиентов.',
    'site.spec.label': 'Наша команда',
    'site.spec.title': 'Наши специалисты',
    'site.spec.subtitle': 'Команда опытных консультантов, которые помогут вам на пути к ипотеке.',
    'site.spec.btn': 'Консультация',
    'site.spec.details': 'Подробнее',
    'site.spec.close': 'Закрыть',
    'site.spec.unrated': 'Пока нет рейтинга',
    'site.spec.book': 'Записаться на консультацию',
    'site.spec.rating': 'Рейтинг: {stars} из 5',
    'site.city.astana': 'Астана',
    'site.city.almaty': 'Алматы',
    'site.prog.label': 'Ипотека',
    'site.prog.title': 'Ипотечные программы',
    'site.prog.subtitle': 'Наши разнообразные ипотечные программы доступны всем клиентам.',
    'site.prog.zoom_hint': 'Дважды нажмите, чтобы увеличить',
    'site.faq.label': 'Часто задаваемые вопросы',
    'site.faq.title': 'Ответы на часто задаваемые вопросы об ипотеке!',
    'site.faq.q1': 'Какие документы нужны для получения ипотеки?',
    'site.faq.a1': '1) документ, удостоверяющий личность (удостоверение личности или паспорт РК), электронная версия также подходит. (оригинал)\n2) Если вы в браке — свидетельство о браке супругов. (оригинал)\n3) По государственным программам — свидетельства о рождении детей до 18 лет (оригинал)\nПо некоторым программам могут понадобиться дополнительные документы — наш специалист подскажет',
    'site.faq.q2': 'Сколько времени занимает предварительное одобрение?',
    'site.faq.a2': 'Наши клиенты получают предварительное одобрение в среднем в течение 24 часов. А в некоторых случаях решение может выйти даже за несколько часов. Если все необходимые документы готовы, процесс значительно ускоряется.',
    'site.faq.q3': 'Ваши услуги бесплатны?',
    'site.faq.a3': 'Консультация по ипотечным программам и выбор выгодной программы — бесплатны.',
    'site.faq.q4': 'Смогу ли я получить ипотеку, если у меня плохая кредитная история?',
    'site.faq.a4': 'Да, это возможно. Мы работаем с клиентами с плохой кредитной историей. Через специальные программы и альтернативные способы финансирования мы стараемся найти решение. На консультации мы проанализируем вашу конкретную ситуацию.',
    'site.faq.q5': 'Можете ли вы помочь получить квартиру в рамках государственной программы?',
    'site.faq.a5': 'Конечно. Мы можем дать полную консультацию по государственным программам, таким как «Новая концепция» (2-10-20 / 5-10-20), 7-20-25, программа «Наурыз». Определим, какая программа подходит для вашей ситуации, и поможем оформить ипотеку.',
    'site.faq.q6': 'Что такое рефинансирование? Выгодно ли оно мне?',
    'site.faq.a6': 'Выгода рефинансирования зависит от вашей конкретной ситуации. Если процентная ставка по вашей оформленной ипотеке значительно выше, чем ставки по текущим рыночным ипотечным программам, то рефинансирование будет для вас выгодным. Для получения полной информации приходите в наш офис на бесплатную консультацию.',
    'site.faq.more_text': 'Не нашли ответ на свой вопрос?',
    'site.faq.more_action': 'Читать посты',

    'site.soc.label': 'Социальные сети',
    'site.soc.title': 'Найдите нас в сети',
    'site.soc.subtitle': 'Новости ипотеки, советы и мнения экспертов — будьте с нами на всех платформах.',
    'site.soc.youtube': 'Бесплатные видеоуроки на YouTube: выгодные способы приобретения жилья. Простое объяснение без банковского жаргона',
    'site.soc.instagram': 'Информация на простом казахском языке. 100% достоверные новости. Результаты нашей работы.',
    'site.soc.tiktok': 'Наш канал в TikTok — всегда свежая и актуальная информация',
    'site.soc.whatsapp': 'Прямая связь\nи консультация',
    'site.partners.label': 'Партнёры',
    'site.partners.title': 'Наши надёжные партнёры',
    'site.partners.intro': 'Мы тесно сотрудничаем с ведущими банками и финансовыми институтами Казахстана. Это позволяет нам предлагать клиентам самые выгодные условия.',
    'site.contact.label': 'Контакты',
    'site.contact.title': 'Мы готовы помочь\nна каждом вашем шаге',
    'site.contact.desc': 'Покупаете ли вы своё первое жильё или хотите рефинансировать — наша команда готова помочь. Без давления, только профессиональный совет.',
    'site.contact.phone': 'Телефон',
    'site.contact.office': 'Офис',
    'site.contact.office_almaty': '🌍 Алматы, Ауэзовский район, Жетысу-1, дом 40 🏢 ТЦ «Елдаулет» 🔹 2-й этаж, офис 7',
    'site.contact.office_astana': '🌍 Астана, Кажымукан 12А 🔹 Отдельный вход, 1-й этаж 🔹 Вход со стороны улицы Сатпаева',
    'site.contact.open_2gis': 'Открыть на карте 2GIS',
    'site.contact.hours': 'Часы работы',
    'site.contact.hours_val': 'Без выходных 10:00 – 19:00',
    'site.contact.schedule': 'График работы',
    'site.contact.schedule_sub1_line1': 'Мы работаем каждый день без выходных!',
    'site.contact.schedule_sub1_prefix': 'Время: ',
    'site.contact.schedule_sub1_hours': '10:00–19:00',
    'site.contact.schedule_sub1_suffix': '',
    'site.contact.schedule_sub2_prefix': 'Без предварительной записи — принимаем в живой очереди. Консультация — ',
    'site.contact.schedule_sub2_free': 'БЕСПЛАТНО!',
    'site.contact.map_almaty': 'Жетысу-1, дом 40. Офис 7',
    'site.contact.map_astana': 'Кажымукан, 12а',
    'site.footer.desc': 'Надёжные ипотечные эксперты с 2021 года. Мы делаем владение жильём доступным и простым.',
    'site.footer.nav': 'Навигация',
    'site.footer.faq': 'Часто задаваемые вопросы',
    'site.footer.socials': 'Соцсети',
    'site.footer.partners': 'Партнёры',
    'site.footer.services': 'Услуги',
    'site.footer.svc1': 'Покупка первого жилья',
    'site.footer.svc2': 'Рефинансирование',
    'site.footer.svc3': 'Инвестиционная ипотека',
    'site.footer.svc4': 'Коммерческая ипотека',
    'site.footer.svc5': 'Государственные программы',
    'site.footer.tagline': 'Ваш дом — наша главная цель.',
    'site.about.check1.title': 'Полный охват рынка',
    'site.about.check1.text': 'Мы сравниваем сотни кредиторов, чтобы вы получили жильё по самой выгодной процентной ставке! (расскажем о преимуществах и недостатках программ)',
    'site.about.check2.title': 'Никаких скрытых комиссий',
    'site.about.check2.text': 'Полная прозрачность с первого звонка. Прежде чем подписать договор, мы объясним каждую цифру.',
    'site.about.check3.title': 'Персональный консультант',
    'site.about.check3.text': 'Вы работаете с одним специалистом, который знает вашу ситуацию и готов помочь в любое время.',
    'site.footer.copy': '© {year} Ипотекалық дәрігер. Все права защищены.',
    'site.footer.policy': 'Политика конфиденциальности',
    'site.footer.terms': 'Условия использования',
    'site.specialists.city': 'Город',
    'site.programs.slide': 'Программа',
    'site.programs.previous': 'Предыдущая программа',
    'site.programs.next': 'Следующая программа',

    'site.nav.menu': 'Меню',
    'site.nav.language': 'Тіл / Язык',
    'site.hero.slides': 'Слайды',
    'site.hero.slide': 'Слайд',
    'site.hero.slide1_alt': 'Ипотечные консультанты — надёжная команда',
    'site.hero.slide2_alt': 'Ипотечные консультанты — встреча',
    'site.spec.previous': 'Предыдущий',
    'site.spec.next': 'Следующий',
    'site.prog.alt': 'Ипотечная программа',
    'site.prog.zoom': 'Увеличить',
    'site.prog.close': 'Закрыть',
    'site.prog.image': 'Изображение программы',

    // ── The privacy policy and terms page ─────────────────────────────────────
    'cookies.title': 'Мы используем файлы cookie',
    'cookies.body':
        'Файлы, необходимые для работы сайта, используются всегда. Аналитические файлы, собирающие статистику, включаем только с вашего согласия.',
    'cookies.policy_link': 'Подробнее — в Политике конфиденциальности',
    'cookies.accept': 'Согласен',
    'cookies.decline': 'Только необходимые',
    'cookies.prefs.title': 'Ваше согласие на аналитические файлы cookie',
    'cookies.prefs.state_granted': 'Сейчас: аналитика включена. Вы можете отозвать согласие в любой момент.',
    'cookies.prefs.state_denied':
        'Сейчас: аналитика отключена. Используются только необходимые для сайта файлы.',
    'cookies.prefs.state_undecided': 'Вы ещё не сделали выбор. Аналитика отключена.',
    'cookies.prefs.withdraw': 'Отозвать согласие',
    'cookies.prefs.ask_again': 'Спросить снова',

    'policy.page.title': 'Политика конфиденциальности и Условия использования — Ипотекалық дәрігер',
    'policy.page.desc': 'Ипотекалық дәрігер — Политика конфиденциальности и Условия использования.',
    'policy.nav.back': 'На главную',
    'policy.hero.badge': 'Последнее обновление: 1 января 2026 года',
    'policy.hero.sub': 'Полная информация о том, как мы используем ваши данные, и об условиях использования сайта',
    'policy.tab.privacy': 'Политика конфиденциальности',
    'policy.tab.terms': 'Условия использования',
    'policy.hero.title_before': 'Страница',
    'policy.hero.title_emphasis': 'правовой',
    'policy.hero.title_after': 'информации',
    'policy.contact.email': 'Email',
    'policy.contact.phone': 'Телефон',
    'policy.side.contents': 'Содержание',
    'policy.side.cta_title': 'Остались вопросы?',
    'policy.side.cta_sub': 'Консультант ответит бесплатно — напишите или позвоните.',
    'policy.side.whatsapp': 'Написать в WhatsApp',
    'policy.misc.updated': 'Обновлено: 1 января 2026',
    'policy.pp.intro.label': 'Введение',
    'policy.pp.intro.h2': 'Политика конфиденциальности данных',
    'policy.pp.intro.p1': 'Компания «Ипотекалық дәрігер» (далее — «Мы», «Компания») считает защиту персональных данных наших клиентов одним из своих ключевых обязательств. Настоящая Политика конфиденциальности регулирует порядок сбора, использования, хранения и защиты персональных данных Компанией при использовании вами нашего веб-сайта ipotekalyk-dariger.kz (далее — «Сайт»).',
    'policy.pp.intro.box': 'Используя Сайт, вы подтверждаете своё согласие на обработку ваших данных в соответствии с условиями, изложенными в настоящей Политике.',
    'policy.pp.collect.label': 'Сбор данных',
    'policy.pp.collect.h2': 'Какие данные собираются',
    'policy.pp.collect.p1': 'Для оказания вам качественных услуг Мы можем собирать следующие данные:',
    'policy.pp.collect.h3a': 'Данные, предоставляемые напрямую',
    'policy.pp.collect.a1': 'Имя, номер телефона и адрес электронной почты — при отправке через контактную форму',
    'policy.pp.collect.a2': 'Сведения, связанные с ипотекой: уровень дохода, кредитная история (если предоставлены добровольно)',
    'policy.pp.collect.a3': 'Содержание переписки и вопросов',
    'policy.pp.collect.h3b': 'Данные, собираемые автоматически',
    'policy.pp.collect.b1': 'IP-адрес и тип браузера',
    'policy.pp.collect.b2': 'Статистика использования сайта (просмотренные страницы, длительность сессии)',
    'policy.pp.collect.b3': 'Время и дата посещения сайта',
    'policy.pp.collect.b4': 'Данные, получаемые через файлы cookie',
    'policy.pp.use.label': 'Цели использования',
    'policy.pp.use.h2': 'Цели использования данных',
    'policy.pp.use.p1': 'Собранные данные используются исключительно в законных целях:',
    'policy.pp.use.l1': 'Ипотечное консультирование и ответы на запросы',
    'policy.pp.use.l2': 'Заключение и исполнение клиентского договора',
    'policy.pp.use.l3': 'Улучшение работы сайта и персонализация контента',
    'policy.pp.use.l4': 'Выполнение требований законодательства (например, налоговая отчётность)',
    'policy.pp.use.l5': 'Выявление рисков мошенничества и угроз безопасности',
    'policy.pp.use.box': 'Мы никогда не продаём и не передаём ваши персональные данные третьим сторонам в маркетинговых или рекламных целях.',
    'policy.pp.share.label': 'Передача данных',
    'policy.pp.share.h2': 'Передача третьим сторонам',
    'policy.pp.share.p1': 'Ваши данные могут быть переданы банкам-партнёрам и организациям только в следующих случаях:',
    'policy.pp.share.l1': 'С вашего явного согласия — для обработки ипотечной заявки',
    'policy.pp.share.l2': 'Если этого требует закон или решение суда',
    'policy.pp.share.l3': 'При продаже или реструктуризации Компании (вы будете уведомлены заранее)',
    'policy.pp.share.p2': 'Все организации-партнёры работают только при условии обеспечения достаточного уровня защиты данных.',
    'policy.pp.cookies.label': 'Cookie',
    'policy.pp.cookies.h2': 'Файлы cookie',
    'policy.pp.cookies.p1': 'Сайт использует файлы cookie для улучшения вашего опыта. Вы можете отключить файлы cookie в настройках браузера в любой момент. Однако это может ограничить некоторые функции сайта.',
    'policy.pp.cookies.l1': 'Обязательные cookie: необходимы для работы сайта — сохраняют сессию пользователя',
    'policy.pp.cookies.l2': 'Аналитические cookie: собирают статистику использования сайта (Google Analytics)',
    'policy.pp.cookies.l3': 'Функциональные cookie: запоминают языковые настройки',
    'policy.pp.rights.label': 'Ваши права',
    'policy.pp.rights.h2': 'Ваши права в отношении персональных данных',
    'policy.pp.rights.p1': 'В соответствии с Законом РК «О персональных данных и их защите» вы имеете следующие права:',
    'policy.pp.rights.l1': 'Доступ к данным, которые хранятся о вас',
    'policy.pp.rights.l2': 'Требование исправить недостоверные данные',
    'policy.pp.rights.l3': 'Удаление данных («право на забвение»)',
    'policy.pp.rights.l4': 'Отзыв согласия на обработку данных',
    'policy.pp.rights.l5': 'Переносимость данных — вы можете получить свои данные и передать их другой организации',
    'policy.pp.rights.p2': 'Заявления рассматриваются в течение 30 дней. Направьте запрос по адресу ipotekalyk_dariger1@mail.ru.',
    'policy.pp.security.label': 'Безопасность',
    'policy.pp.security.h2': 'Безопасность данных',
    'policy.pp.security.p1': 'Компания применяет технические и организационные меры для защиты данных клиентов:',
    'policy.pp.security.l1': 'Защита передачи данных с помощью SSL/TLS-шифрования',
    'policy.pp.security.l2': 'Ограничение доступа к данным (только уполномоченные сотрудники)',
    'policy.pp.security.l3': 'Антивирусные программы, защищающие системы от киберугроз',
    'policy.pp.security.l4': 'Срок хранения данных — 5 лет после завершения обслуживания',
    'policy.pp.contact.label': 'Контакты',
    'policy.pp.contact.h2': 'Ваши вопросы и жалобы',
    'policy.pp.contact.p1': 'Если у вас есть любые вопросы или опасения относительно настоящей Политики, свяжитесь с нами:',
    'policy.pp.contact.h4': 'Контакт по вопросам защиты данных',
    'policy.tt.intro.label': 'Общие положения',
    'policy.tt.intro.h2': 'Условия использования',
    'policy.tt.intro.p1': 'Настоящие Условия использования регулируют правовые отношения между пользователем и Компанией при использовании сайта «Ипотекалық дәрігер». Используя сайт, вы полностью принимаете эти условия.',
    'policy.tt.intro.box': 'Содержание сайта носит исключительно информационный характер. Оформление ипотеки проводится через персональную консультацию. Указанные на сайте ставки не являются конкретным предложением.',
    'policy.tt.elig.label': 'Пользователи',
    'policy.tt.elig.h2': 'Условия использования',
    'policy.tt.elig.p1': 'Для использования сайта должны быть соблюдены следующие условия:',
    'policy.tt.elig.l1': 'Возраст 18 лет и старше',
    'policy.tt.elig.l2': 'Соблюдение законодательства Республики Казахстан',
    'policy.tt.elig.l3': 'Воздержание от предоставления ложной информации и мошеннических действий',
    'policy.tt.elig.l4': 'Использование сайта только в законных целях',
    'policy.tt.ip.label': 'Интеллектуальная собственность',
    'policy.tt.ip.h2': 'Авторское право и интеллектуальная собственность',
    'policy.tt.ip.p1': 'Всё содержимое сайта — тексты, логотипы, изображения, элементы дизайна, программный код — является собственностью компании «Ипотекалық дәрігер» и охраняется авторским правом.',
    'policy.tt.ip.l1': 'Запрещается копировать, распространять или использовать любой контент в коммерческих целях без письменного разрешения',
    'policy.tt.ip.l2': 'Разрешается читать контент и создавать ссылки в личных, некоммерческих целях',
    'policy.tt.ip.l3': 'При выявлении нарушения применяются меры правового характера',
    'policy.tt.prohib.label': 'Запрещено',
    'policy.tt.prohib.h2': 'Запрещённые действия',
    'policy.tt.prohib.p1': 'При использовании сайта запрещается:',
    'policy.tt.prohib.l1': 'Распространять вредоносные программы, вирусы или деструктивный код',
    'policy.tt.prohib.l2': 'Собирать данные с помощью автоматических ботов (web scraping)',
    'policy.tt.prohib.l3': 'Создавать помехи работе сайта или пытаться его взломать',
    'policy.tt.prohib.l4': 'Обманно использовать имя другого пользователя или компании',
    'policy.tt.prohib.l5': 'Использовать сайт в незаконных целях или в нарушение законодательства РК',
    'policy.tt.prohib.box': 'В случае нарушения условий Компания оставляет за собой право ограничить доступ к сайту и применить меры правового характера.',
    'policy.tt.disc.label': 'Пределы ответственности',
    'policy.tt.disc.h2': 'Отказ от ответственности',
    'policy.tt.disc.p1': '«Ипотекалық дәрігер» предоставляет сайт «как есть». Компания не несёт ответственности за:',
    'policy.tt.disc.l1': 'Последствия финансовых решений, принятых на основе содержания сайта',
    'policy.tt.disc.l2': 'Временную недоступность сайта или технические сбои',
    'policy.tt.disc.l3': 'Содержание сторонних сайтов (переход по ссылкам)',
    'policy.tt.disc.l4': 'Ущерб, возникший из-за обстоятельств вне нашего контроля (форс-мажор)',
    'policy.tt.disc.p2': 'Ипотечные ставки и условия на сайте носят информационный характер и не являются официальным предложением банка. Конкретные условия определяются на персональной консультации.',
    'policy.tt.links.label': 'Внешние ссылки',
    'policy.tt.links.h2': 'Ссылки на сторонние сайты',
    'policy.tt.links.p1': 'На нашем сайте могут присутствовать ссылки на банки-партнёры и организации. Эти ссылки предоставлены исключительно для удобства. «Ипотекалық дәрігер» не несёт ответственности за содержание и политику этих сайтов. Рекомендуем ознакомиться с их собственными условиями перед использованием.',
    'policy.tt.changes.label': 'Изменения',
    'policy.tt.changes.h2': 'Порядок изменения условий',
    'policy.tt.changes.p1': 'Компания оставляет за собой право изменять настоящие Условия использования в любое время. В случае существенных изменений:',
    'policy.tt.changes.l1': 'На сайте публикуется уведомление',
    'policy.tt.changes.l2': 'Обновляется дата последнего обновления',
    'policy.tt.changes.l3': 'Зарегистрированным пользователям направляется уведомление по email',
    'policy.tt.changes.p2': 'Если вы продолжаете пользоваться сайтом после обновления условий, считается, что вы приняли новые условия.',
    'policy.tt.law.label': 'Законодательство',
    'policy.tt.law.h2': 'Применимое законодательство',
    'policy.tt.law.p1': 'Настоящие Условия регулируются в соответствии с законодательством Республики Казахстан. Любой спор или разногласие рассматривается в судах города Алматы.',
    'policy.tt.law.h4': 'Контакт по юридическим вопросам',

    // The four static pages' own head, shared by the component and the build-time
    // prerenderer through `STATIC_PAGES` — one description, so the two cannot drift.
    'booking.page.title': 'Запись на консультацию — Ипотекалық дәрігер',
    'booking.page.desc': 'Выберите удобное время для бесплатной ипотечной консультации онлайн.',
    'blog.page.title': 'Посты — Ипотекалық дәрігер',
    'blog.page.desc': 'Статьи об ипотеке: программы, документы и советы экспертов.',
};
